import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsLoggedIn,
  selectUserState,
  selectUsername,
  userLoginAction,
  userLogoutAction,
  userStateAction,
} from '../../ducks';
import { UserState } from '../../ducks/user';
import { checkAuthentication } from '../../apis/user';
import { setHashedIdCookie } from '../../cookie';

/**
 * Custom hook to check if the user is logged in,
 * calls api and returns calling state value in first item in array
 * if state is UserState.PENDING then it's waiting for a response from
 *  backend.
 * Saves result into redux state to avoid api calls every time page loaded
 * if any api call returns unauthorised error then redux state should be set to logged out
 * @param history --  if set then redirects to login page after checking if the user is not logged in
 * @returns {[UserState, boolean]}
 */
export const useAuthCheck = (history, nsfwItem) => {
  const dispatch = useDispatch();
  const userState = useSelector(selectUserState);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const userName = useSelector(selectUsername);

  useEffect(() => {
    const checkAuth = async () => {
      dispatch(userStateAction(UserState.PENDING));
      try {
        const { user } = await checkAuthentication();
        dispatch(userLoginAction({ ...user }));
      } catch (e) {
        dispatch(userLogoutAction());
      }
    };
    if (UserState.CHECKED === userState && isLoggedIn) {
      setHashedIdCookie(userName); 
    }    
    if (UserState.UNCHECKED === userState && !isLoggedIn) {
      checkAuth().finally(() => { /* no-op */ });
    }
    if (UserState.CHECKED === userState && !isLoggedIn && history) {
      history.push({
        pathname: nsfwItem ? '/nslogin' : '/login',
        state: {
          nsfwItem: nsfwItem,
          prevLocation: history.location,
        },
      });
    }
  }, [history, userState, isLoggedIn]);

  return [userState, isLoggedIn];
};
